<template>
  <div v-if="show">
    <ModalInputNickname :show="!hasNickname" @close="close" />
  </div>
</template>

<script>
import ModalInputNickname from '@/components/Modal/ModalInputNickname.vue';
import _ from 'lodash';

export default {
  components: {
    ModalInputNickname,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    userData() {
      return this.$store.getters['user/userData'];
    },
    hasNickname() {
      return this.userData?.nickName && this.userData.nickName !== '-';
    },
  },
  methods: {
    close(force) {
      if (this.hasNickname || force) {
        const queryData = _.cloneDeep(this.$route.query);
        delete queryData.isFirstLogin;
        this.$router.replace({query: queryData});
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
